// Presentation of canonical observations. This module grants no authority.
export function providerStatus(provider,{fresh=true}={}) {
  if(!fresh)return {tone:'off',label:'Durum güncellenemiyor'};
  const status=provider.connection_status;
  if(status==='CONNECTED')return {tone:'connected',label:'Bağlı'};
  if(['ERROR','DENIED','AUTH_FAILED','INVALID_CREDENTIAL','UNAVAILABLE'].includes(status))
    return {tone:'error',label:'Sorun var'};
  if(['CONFIGURED','READY','DISCONNECTED','DEGRADED','RATE_LIMITED'].includes(status))
    return {tone:'ready',label:status==='CONFIGURED'?'Doğrulama bekliyor':['DEGRADED','RATE_LIMITED'].includes(status)?'Kısıtlı / sorun incelenmeli':'Bağlanmaya hazır'};
  return {tone:'off',label:'Henüz taranmadı'};
}
export function modelStatus(model) {
  const pm=model.route_decision||{};
  if(pm.mode==='ENFORCE' && pm.selection_eligible===true && model.tenant_enabled===true
      && model.connection_status==='CONNECTED')
    return {tone:'connected',label:'Etkin · kullanıma uygun'};
  if(model.tenant_enabled!==true)return model.connection_status==='CONNECTED'
    ?{tone:'ready',label:'Etkinleştirme bekliyor'}:{tone:'off',label:'Kapalı'};
  if(['DENIED','ERROR','DISCONNECTED'].includes(model.connection_status))
    return {tone:'error',label:'Bağlantı gerekli'};
  if(model.latest_availability?.status==='UNAVAILABLE')
    return {tone:'error',label:'Erişilemiyor'};
  return {tone:'ready',label:'Koşullar bekleniyor'};
}
export function filterModels(models,{search='',provider='',state=''}={}) {
  const needle=search.trim().toLocaleLowerCase('tr');
  return models.filter(model=>(!provider||model.provider_key===provider)
    &&(!state||modelStatus(model).tone===state)
    &&(!needle||[model.deployment_key,model.upstream_model,model.provider_key]
      .some(value=>String(value||'').toLocaleLowerCase('tr').includes(needle))));
}
export function latestTest(model) {
  const tests=(model.verified_capabilities||[]).filter(test=>Number.isFinite(Date.parse(test.observed_at)));
  return tests.reduce((last,next)=>!last||Date.parse(next.observed_at)>Date.parse(last.observed_at)?next:last,null);
}
export function orderedActivity(events) {
  return events.map((event,index)=>({event,index})).sort((a,b)=>{
    const x=Date.parse(a.event.occurred_at),y=Date.parse(b.event.occurred_at);
    if(!Number.isFinite(x))return Number.isFinite(y)?1:a.index-b.index;
    if(!Number.isFinite(y))return -1;
    return y-x||a.index-b.index;
  }).map(row=>row.event);
}
export function operationAvailability(snapshot,kind,providerKey,modelKey) {
  const grant=(snapshot.operations||[]).find(op=>op.kind===kind&&op.provider_key===providerKey
    &&(op.model_key||'')===(modelKey||''));
  return grant?.available===true?{available:true,reason:''}:
    {available:false,reason:grant?.reason||'Bu işlem için doğrulanmış bağlantı henüz yok.'};
}
